<template>
    <div class="warpper padding-sm">
        <div class="flex align-center justify-between margin-bottom-sm list-title">
            <b>客服管理</b>
            <span class="add-btn" @click="addService(false)"
            >添加
            </span>
        </div>
        <div class="ship-list">
            <el-table :data="lists" header-row-class-name="table-header"
                      border
                      style="width: 100%; border-radius: 10px">
                <el-table-column label="姓名" prop="name">
                    <template slot-scope="scope">
                        <div class="flex justify-center"> {{scope.row.name}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="电话" prop="phone">
                    <template slot-scope="scope">
                        <div class="flex justify-center">{{scope.row.phone}}</div>
                    </template>
                </el-table-column>
<!--                <el-table-column label="服务人数" prop="user_num">-->
<!--                    <template slot-scope="scope">-->
<!--                        <div class="flex justify-center">{{scope.row.user_num}}</div>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div class="flex justify-center">
                            <el-button @click="addService(scope.row)" type="text">编辑</el-button>
                            <span class="padding-lr-sm"></span>
                            <el-button style="color: red" @click="deleteItem(scope.row.id)" type="text">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <add-service-dialog :applyDialogVisible="applyDialogVisible" :id="cur_id" :info="cur_item" @watchState="watchState"></add-service-dialog>
    </div>
</template>

<script>
    import {getKefuList, delKefu} from '@/api/organiz'
    import AddServiceDialog from "@/components/AddServiceDialog.vue";
    export default {
        name: "serverList",
        data() {
            return {
                lists: [],
                cur_item: null,
                cur_id: 0,
                applyDialogVisible: false
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            }
        },
        created() {
            this.$emit('setIndex', [6, 0], '客服管理')
            this.init()
        },
        components: {AddServiceDialog},
        methods: {
            //  页面加载时请求
            async init() {
                let _data = await getKefuList()
                if (_data.status === 200) {
                    this.lists = _data.data
                    this.total = _data.count
                }else{
                    this.lists = []
                }
            },
            addService(data) {
                this.applyDialogVisible = true
                if (data) {
                    this.cur_item = JSON.parse(JSON.stringify(data))
                    this.cur_id = data.id
                }else {
                    this.cur_item = null
                    this.cur_id = 0
                }
            },
            deleteItem(id) {
                this.$confirm("确定要删除该客服吗", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.delKefu(id)
                })
            },
            async delKefu(id) {
                let _data = await delKefu(id)
                if (_data.status === 200) {
                    this.init()
                    this.$message.success(_data.msg)
                }
            },
            watchState(state) {
                if (state) this.init()
                this.applyDialogVisible = false;
            },
        },
        filters: {},
        watch: {},
    }
</script>

<style scoped lang="scss">
    .warpper {
        background: #fff;
        border-radius: 10px;

        .list-title {
            b {
                font-size: 26px;
                line-height: 34px;
            }

            .add-btn {
                display: block;
                width: 200px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#0a2240, #0a2240);
                background-blend-mode: normal, normal;
                border-radius: 20px;
                font-size: 16px;
                color: #fff;
                cursor: pointer;
            }
        }
    }
</style>